import { OnlineComponent } from '@shared/components/online/online.component';
import { HeaderComponent } from './header/header.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';

export { MainLayoutComponent, HeaderComponent, SidebarComponent };

export const containerComponents = [
  MainLayoutComponent,
  HeaderComponent,
  SidebarComponent,
  OnlineComponent,
];
